//设备
import {getLanguageStr} from "@/util/language"

const state = {
    currentIndex: 0,
    btnGroup: [{
        title: getLanguageStr("word706","报警详情"),
    }]
}
const getters = {
    currentIndex: state => {
        return state.currentIndex
    },
    btnGroup: state => {
        return state.btnGroup
    }
}
const actions = {
}
const mutations = {
    GET_CURRENTINDEX: (state, index) => {
        state.currentIndex = index
    },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/alarmDetail.js